<template>
  <div class="news_page">
    <DashHeader />
    <NewsItems />
 <p>
      <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
 </p> 
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
import NewsItems from "@/components/NewsItems.vue";
export default {
  name: "News",
  components: {
    DashHeader,
    NewsItems
  }
};
</script>
